import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { chainesLocales } from './../include/chainesLocales';
import { URL_QUEST } from './../include/urlApi';

class Questionnaire extends Component {
    get labels() {
        return chainesLocales['Questionnaire'][this.props.lang];
    }

    chargementPage() {
        if (document.querySelector) {
            // Cacher le menu sandwich
            if (document.body.classList) document.querySelector('#menuPiv').classList.remove('show');

            // Retourner au début du iframe
            if (window.scrollTo && process.env.REACT_APP_ENV !== 'devl') document.querySelector('#quest-v').contentWindow.scrollTo(0, 0);
        }

        // Cacher le loading spinner
        document.getElementById('questionnaire-loading').style.display = "none";
    }

    componentDidMount() {
        if (document.querySelector) document.querySelector('#quest-v').onload = this.chargementPage;
    }

    render() {
        if (URL_QUEST) {
            return (
                <React.Fragment>
                    <div id="questionnaire-loading"><div /><h1>{this.props.lang === "FR" ? "Chargement..." : "Loading..."}</h1></div>
                    <iframe id="quest-v" title={this.labels.iframeTitle} className="w-100 flex-grow-1 flex-shrink-0 bg-white" scrolling="yes" frameBorder="no" src={URL_QUEST + '?lang=' + this.props.lang} />
                </React.Fragment>
            );
        }
    }
}

Questionnaire.propTypes = {
    lang: PropTypes.oneOf(['FR', 'AN', 'CR', 'CS']).isRequired,
    config: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
};

export default Questionnaire;